import { render, staticRenderFns } from "./LetterCompanyCard.vue?vue&type=template&id=4b7a6af8"
import script from "./LetterCompanyCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LetterCompanyCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports